import api from '../api-new/http';
import { appUrls } from '../api-new/urls';

export async function calculateTotalAssets(data: Portfolios[]) {
    let total = 0;
    for (const item of data) {
        const tickerVal = await getTickerVal(item.ticker);
        total += Number(item.amount) * tickerVal;
    }
    return total;
}

export async function calculateTotalAssetsLocked(data: Portfolios[]) {
    let total = 0;
    for (const item of data) {
        const tickerVal = await getTickerVal(item.ticker);
        total += Number(item.locked) * tickerVal;
    }
    return total;
}

export const getTickerVal = async (ticker: string) => {
    try {
        if (sessionStorage.getItem(ticker)) {
            return sessionStorage.getItem(ticker);
        }
        const response = await api.get(`${appUrls.stockURL}/ticker/price-board/${ticker}`);
        const price = response.data[0]?.["('match', 'match_price')"];
        const priceResponse =  price ? price : response.data[0]?.["('listing', 'ref_price')"];
        sessionStorage.setItem(ticker, priceResponse.toString());
        return priceResponse;
    } catch (error) {
        // console.log(error);
        return 0;
    }
};

interface Portfolios {
    id: string;
    uid: string;
    ticker: string;
    amount: string;
    createdAt: string;
    updateAt: string;
    locked: string;
}
